import { ListItem } from '@apollo/space-kit/ListItem';
import classnames from 'classnames';
import React from 'react';

import { LaunchesListInfo } from '../helpers/computeLaunchesListInfo';
import { LaunchesListHeader } from '../LaunchesList';
import { LaunchesListStatusIcon } from '../LaunchesListStatusIcon';

import { LaunchesListItemInfo } from './LaunchesListItem';

export const LaunchesListSummaryItem = ({
  launchesInfo: { kind, launches },
  className,
}: {
  launchesInfo: LaunchesListInfo;
  className?: string;
}) => {
  const summaryInfo: Map<LaunchesListItemInfo['progress'], number> = new Map();

  launches.forEach(({ progress }) => {
    summaryInfo.set(progress, (summaryInfo.get(progress) ?? 0) + 1);
  });

  return (
    <div className={classnames(className, 'flex flex-col items-start')}>
      <LaunchesListHeader kindOfStep={kind} />
      <ListItem as={<div className="px-0" />} interactive={false}>
        <div className="flex flex-wrap items-center text-sm">
          {summaryInfo.has('waiting') ? (
            <div className="mr-4 flex items-center">
              <div className="mr-2 flex flex-col justify-center">
                <LaunchesListStatusIcon progress="waiting" />
              </div>
              {summaryInfo.get('waiting')} waiting
            </div>
          ) : null}
          {summaryInfo.has('success') ? (
            <div className="mr-4 flex items-center">
              <div className="mr-2 flex flex-col justify-center">
                <LaunchesListStatusIcon progress="success" />
              </div>
              {summaryInfo.get('success')} succeeded
            </div>
          ) : null}
          {summaryInfo.has('failure') ? (
            <div className="flex items-center">
              <div className="mr-2 flex flex-col justify-center">
                <LaunchesListStatusIcon progress="failure" />
              </div>
              {summaryInfo.get('failure')} failed
            </div>
          ) : null}
        </div>
      </ListItem>
    </div>
  );
};
